var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51953 14.4365L14.4325 9.52344",
    stroke: "#212122",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5705 15.1084C13.3102 16.2488 13.1128 17.4178 12.2583 18.2723L9.26305 21.2675C8.28465 22.2459 6.69834 22.2459 5.71994 21.2675L2.73381 18.2814C1.7554 17.303 1.7554 15.7167 2.73381 14.7383L5.72902 11.743C6.43096 11.0411 7.76508 10.6357 8.91154 11.4659M15.1103 12.5685C16.2507 13.3082 17.4197 13.1109 18.2742 12.2564L21.2694 9.26114C22.2478 8.28273 22.2478 6.69641 21.2694 5.718L18.2833 2.73185C17.3049 1.75344 15.7186 1.75344 14.7402 2.73185L11.7449 5.72709C11.043 6.42903 10.6377 7.76315 11.4679 8.90962",
    stroke: "#212122",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/Website.7aed35399c8a54082c5b28b58f09f75f.svg";
export { ForwardRef as ReactComponent };